var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_894_18969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.13705 0.253C5.21703 0.172835 5.31202 0.109227 5.41661 0.0658143C5.52119 0.0224017 5.63331 3.70804e-05 5.74655 0L12.6535 0C12.8823 0 13.1008 0.09085 13.2629 0.253L18.147 5.13705C18.3091 5.29805 18.4 5.5177 18.4 5.74655V12.6535C18.4 12.7667 18.3776 12.8788 18.3342 12.9834C18.2908 13.088 18.2272 13.183 18.147 13.2629L13.2629 18.147C13.183 18.2272 13.088 18.2908 12.9834 18.3342C12.8788 18.3776 12.7667 18.4 12.6535 18.4H5.74655C5.63331 18.4 5.52119 18.3776 5.41661 18.3342C5.31202 18.2908 5.21703 18.2272 5.13705 18.147L0.253 13.2629C0.172835 13.183 0.109227 13.088 0.0658143 12.9834C0.0224017 12.8788 3.70804e-05 12.7667 0 12.6535L0 5.74655C0 5.5177 0.09085 5.2992 0.253 5.13705L5.13705 0.253ZM6.10305 1.725L1.725 6.1042V12.2958L6.1042 16.675H12.2958L16.675 12.2958V6.1042L12.2958 1.725H6.10305ZM4.6 8.9125C4.6 8.68375 4.69087 8.46437 4.85262 8.30262C5.01437 8.14087 5.23375 8.05 5.4625 8.05H12.9375C13.1662 8.05 13.3856 8.14087 13.5474 8.30262C13.7091 8.46437 13.8 8.68375 13.8 8.9125C13.8 9.14125 13.7091 9.36063 13.5474 9.52238C13.3856 9.68413 13.1662 9.775 12.9375 9.775H5.4625C5.23375 9.775 5.01437 9.68413 4.85262 9.52238C4.69087 9.36063 4.6 9.14125 4.6 8.9125Z",
    fill: "#51CDA0",
    stroke: "#51CDA0",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_894_18969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.4,
    height: 18.4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabled);
export default __webpack_public_path__ + "static/media/disabled.76b49f54225671dc036ad1bbf6df2184.svg";
export { ForwardRef as ReactComponent };